import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';

export class LineChartConfig extends ChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    const series = data.map((seriesData, index) => ({
      ...seriesData,
      name: seriesData.name,
      stack: seriesData?.stack ? "sum" : null,
      type: SeriesType.Line,
      symbol: 'circle', // force circle symbol
      symbolSize: 8, // optional: adjust as needed
      label: {
        show: true,
        position: 'top',
        formatter: seriesData.label?.formatter ?? ((params) => `${parseInt(params.value)?.toFixed(1)}%`),
      },
      lineStyle: {
        width: 2,
        color: colors[index % colors.length],
      },
      itemStyle: {
        color: colors[index % colors.length], // filled circle
        borderColor: colors[index % colors.length], // same as fill for full circle
        borderWidth: 0, // 0 = no outline
      },
      data: (seriesData.data ?? []).map(point => {
        if (point?.value !== undefined) {
          return { ...point };
        }
        return { value: point };
      }),
    })) as SeriesOption[];

    return {
      xAxis: {
        type: 'category',
        data: categories,
        axisLabel: { formatter: null }
      },
      yAxis: {
        type: 'value',
        max: (value: any) => value.max + 10,
        axisLine: { show: true },
        splitLine: { show: true },
        axisLabel: { formatter: (value: any) => value + '%' }
      },
      series,
    };
  }
}
